import axios from "axios";

const externalAxiosClient = axios.create({
  timeout: 10000,
});

export const externalGet = async <T>(url: string): Promise<T> => {
  const { data } = await externalAxiosClient.get<T>(url);
  return data;
};

export default externalAxiosClient;
